export default {
  RESERVED: {
    id: 1,
    name: 'reserved'
  },
  CHECKED_IN: {
    id: 2,
    name: 'checked in'
  },
  DEPARTED: {
    id: 3,
    name: 'departed'
  },
  CANCELLED: {
    id: 4,
    name: 'cancelled'
  }
};
